var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-book"},[_c('OrgSelectorComponent',{attrs:{"showGroup":[1,6],"showCheckBox":[]},on:{"userClick":_vm.onUserClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }